/**
 * Lights by Blackalogy — Light ON/OFF toggle
 * Desktop already gets the crossfade purely from CSS (:hover). This script
 * only adds tap-to-toggle for touch devices (and click/keyboard as a
 * bonus on desktop), toggling a single `is-on` class. No image swapping,
 * no fetching — every image is already in the DOM.
 *
 * Tap behavior:
 * - Tap a tile: lights it on (and switches off any other tile that was on
 *   — used by multi-tile layouts like the lighting-comparison section so
 *   only one variant is lit at a time).
 * - Tap the same tile again, or tap anywhere else on the page: back to OFF.
 */
(function () {
  function setOn(el, isOn) {
    el.classList.toggle('is-on', isOn);
    el.setAttribute('aria-pressed', isOn ? 'true' : 'false');
  }

  function toggle(el) {
    var willOpen = !el.classList.contains('is-on');
    document.querySelectorAll('.lb-light-toggle.is-on').forEach(function (other) {
      if (other !== el) setOn(other, false);
    });
    setOn(el, willOpen);
  }

  function initLightToggles(root) {
    var toggles = (root || document).querySelectorAll('.lb-light-toggle[data-light-toggle]');
    toggles.forEach(function (el) {
      if (el.dataset.lightToggleReady) return;
      el.dataset.lightToggleReady = 'true';

      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
      }
      el.setAttribute('role', 'button');
      if (!el.hasAttribute('aria-pressed')) {
        el.setAttribute('aria-pressed', 'false');
      }

      el.addEventListener('click', function (event) {
        event.stopPropagation();
        toggle(el);
      });

      el.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          event.stopPropagation();
          toggle(el);
        }
      });
    });
  }

  // Any click/tap that wasn't on a toggle (they stop propagation above)
  // counts as "tap elsewhere" — switch everything back to OFF.
  document.addEventListener('click', function () {
    document.querySelectorAll('.lb-light-toggle.is-on').forEach(function (el) {
      setOn(el, false);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initLightToggles(document);
    });
  } else {
    initLightToggles(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initLightToggles(event.target);
  });
})();
